import { Box } from '@mui/material'
import { withStyles } from 'tss-react/mui'

const BgImageHOC = (color: string) =>
  withStyles(Box, {
    root: {
      backgroundColor: color,
      borderRadius: '2px'
    }
  })

export default BgImageHOC
